import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { closeModal } from "../../redux/features/modalSlice";
import { successToast,errorToast } from "../../Utils/toast";
import { useCreateCategoryMutation } from "../../redux/services/categoriesService/categories.Services";
function CreateCategory({ refreshData }) {
  const dispatch = useDispatch();
  const [preview, setPreview] = useState(null);
  const [formData, setFormData] = useState({
    name: "",
    description: "",
    status: "Active",
    image: null,
  });
  const [createCategory, { isLoading }] =
    useCreateCategoryMutation();
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };
  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setFormData({
        ...formData,
        image: file,
      });
      setPreview(URL.createObjectURL(file));
    }
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const form = new FormData();
      form.append("name", formData.name);
      form.append("description", formData.description);
      form.append("status", formData.status);
      form.append("image", formData.image);
    const res=  await createCategory(form).unwrap();
     successToast( res?.message || "Category Created Successfully 🚀");
      refreshData?.();
      dispatch(closeModal());
    } catch (error) {
      console.log(error);
     errorToast(error?.data?.message || "Error Creating Category ❌")
    }
  };
  return (
    <div className="create-category-wrapper">
      <form onSubmit={handleSubmit}>
        <div className="mb-3">
          <label className="form-label">
            Category Name
          </label>
          <input
            type="text"
            name="name"
            className="form-control"
            placeholder="Enter Category Name"
            value={formData.name}
            onChange={handleChange}
          />
        </div>
        <div className="mb-3">
          <label className="form-label">
            Description
          </label>
          <textarea
            name="description"
            className="form-control"
            rows="4"
            placeholder="Enter Description"
            value={formData.description}
            onChange={handleChange}
          />

        </div>
        <div className="mb-3">
          <label className="form-label">
            Status
          </label>

          <select
            name="status"
            className="form-select"
            value={formData.status}
            onChange={handleChange}
          >
            <option value="Active">
              Active
            </option>

            <option value="Inactive">
              Inactive
            </option>
          </select>
        </div>
        <div className="mb-3">

          <label className="form-label">
            Category Image
          </label>
          <input
            type="file"
            className="form-control"
            accept="image/*"
            onChange={handleImageChange}
          />
        </div>
        {preview && (
          <div className="mb-3">
            <img
              src={preview}
              alt="preview"
              width="120"
              style={{
                borderRadius: "10px",
                border: "1px solid #ddd",
                padding: "5px",
              }}
            />

          </div>
        )}

        {/* BUTTONS */}
        <div className="d-flex gap-2">

          <button
            type="submit"
            className="btn btn-primary"
            disabled={isLoading}
          >
            {
              isLoading
                ? "Creating..."
                : "Create Category"
            }
          </button>

          <button
            type="button"
            className="btn btn-secondary"
            onClick={() => dispatch(closeModal())}
          >
            Cancel
          </button>

        </div>

      </form>

    </div>
  );
}

export default CreateCategory;